import styled, { css } from 'styled-components'

import * as button from './button'
import * as copy from './copy'
import * as glyphs from '../icons/glyphs/index'
import * as COLORS from '../constants/colors'
import * as BREAKPOINT from '../constants/breakpoints'

export const Count = styled(copy.S)`
  display: none;
  color: ${COLORS.GREY_SHADE_1};
  padding: 0 16px;
`

export const Button = styled.button`
  ${button.unstyledButtonCss};

  text-decoration: none;

  width: 32px;
  height: 32px;
  text-align: center;
  padding: 0px;
  align-items: center;
  background-color: ${COLORS.PRIMARY_WHITE};
  border-radius: 4px;
  box-sizing: border-box;
  justify-content: center;
  margin-right: 8px;
  position: flex;
  transition:
    background-color 0.3s ease,
    color 0.3s ease;

  ${copy.Base} {
    line-height: 32px;
    margin-top: -4px;
  }

  ${copy.L} {
    color: ${COLORS.GREY_SHADE_2};
  }

  &:hover {
    background-color: ${COLORS.PRIMARY_BLUE};

    ${copy.L} {
      color: ${COLORS.PRIMARY_WHITE};
    }
  }
`

type PaginationItemProps = {
  selected?: boolean
}
export const Item = styled.li<PaginationItemProps>`
  display: inline-block;
  list-style: none;
  max-height: 26px;

  ${({ selected }) => {
    if (selected) {
      return css`
        ${Button} {
          background-color: ${COLORS.PRIMARY_BLUE};

          ${copy.L} {
            color: ${COLORS.PRIMARY_WHITE};
          }
        }
      `
    }
  }}
`

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;

  ${glyphs.stroke.CaretDown} {
    color: ${COLORS.GREY_SHADE_2};
    margin-right: 8px;
    transform: rotate(90deg);
  }

  ${glyphs.stroke.CaretUp} {
    color: ${COLORS.GREY_SHADE_2};
    transform: rotate(90deg);
  }

  ol {
    padding: 0;
  }
`

export const Arrow = styled(button.UnstyledButton)<{ $disabled: boolean }>`
  @media not screen and ${BREAKPOINT.TABLET} {
    align-items: center;
    background-color: ${COLORS.PRIMARY_WHITE};
    border-radius: 4px;
    box-sizing: border-box;
    height: 32px;
    width: 32px;
    justify-content: center;
    padding: 0px 10px;
    position: flex;
    transition:
      background-color 0.3s ease,
      color 0.3s ease;
    margin-top: 5px;

    ${glyphs.stroke.CaretDown} {
      margin-top: -6px;
      margin-left: -2px;
    }

    ${glyphs.stroke.CaretUp} {
      margin-top: -6px;
    }

    &:hover {
      background-color: ${COLORS.PRIMARY_BLUE};

      ${glyphs.stroke.CaretDown}, ${glyphs.stroke.CaretUp} {
        color: ${COLORS.PRIMARY_WHITE};
      }
    }
  }

  ${({ disabled }) => {
    if (disabled) {
      return css`
        cursor: not-allowed;

        ${glyphs.stroke.CaretDown} {
          color: ${COLORS.GREY_SHADE_4};
        }

        ${glyphs.stroke.CaretUp} {
          color: ${COLORS.GREY_SHADE_4};
        }
      `
    }
  }}
`

export const EllipsisItem = styled(Item)<Omit<PaginationItemProps, 'selected'>>`
  pointer-events: none;
  margin-right: 8px;

  &::after {
    content: '…';
    ${copy._largeStyle}
    color: ${COLORS.GREY_SHADE_2};
  }
`
